import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img-cms/icon/warnning@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-1395f7e1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-info"
};
const _hoisted_2 = {
  key: 0,
  class: "name"
};
const _hoisted_3 = {
  class: "warnning"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "合作状态异常，请与火花学院商务取得联系。", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "app-key-title"
}, "令牌", -1));
const _hoisted_8 = {
  key: 0,
  class: "app-key"
};
const _hoisted_9 = {
  key: 1,
  class: "app-key-title"
};
const _hoisted_10 = {
  key: 2,
  class: "app-key"
};
const _hoisted_11 = {
  class: "user-count"
};
const _hoisted_12 = {
  class: "header"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-count-title"
}, "授权用量", -1));
const _hoisted_14 = {
  class: "progress"
};
const _hoisted_15 = {
  class: "percentage-value"
};
const _hoisted_16 = {
  class: "text"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pencent"
}, "%", -1));
const _hoisted_18 = {
  class: "used"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "user-point"
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "used-title"
}, "已授权用户数", -1));
const _hoisted_21 = {
  class: "number"
};
const _hoisted_22 = {
  class: "residue"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "residue-point"
}, null, -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "residue-title"
}, "剩余可授权用户", -1));
const _hoisted_25 = {
  class: "number"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-record-title"
}, "最近登录时间", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_page_header = _resolveComponent("el-page-header");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_el_space = _resolveComponent("el-space");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, {
    class: "el-home-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "el-home-header"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_page_header, {
        content: "首页"
      })]),
      _: 1
    }), _createVNode(_component_el_main, {
      class: "el-home-main"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "el-home-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_ctx.user.length !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.user.name), 1)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_6, 512), [[_vShow, _ctx.user.status === 0]]), _createElementVNode("div", {
            class: _normalizeClass(["app-key-div", {
              margin_top: _ctx.user.status === 1
            }])
          }, [_hoisted_7, _ctx.user.length !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.user.appKey), 1)) : _createCommentVNode("", true), _ctx.user.length !== 0 && _ctx.showAppKeySecret ? (_openBlock(), _createElementBlock("span", _hoisted_9, "密钥")) : _createCommentVNode("", true), _ctx.user.length !== 0 && _ctx.showAppKeySecret ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.user.accessKeySecret), 1)) : _createCommentVNode("", true), !_ctx.showAppKeySecret ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            type: "primary",
            class: "show-full-key",
            onClick: _ctx.showFullKey
          }, {
            default: _withCtx(() => [_createTextVNode("查看密钥")]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)], 2)])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_el_popover, {
            placement: "top",
            width: 180,
            trigger: "click",
            content: "请联系火花学院商务咨询增加授权"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode("增加授权")]),
              _: 1
            })]),
            _: 1
          })]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_progress, {
            type: "circle",
            width: 192,
            "stroke-width": 26,
            color: "#FE5702",
            percentage: _ctx.user.totalCount === 0 ? 100 : _ctx.user.usedCount / _ctx.user.totalCount * 100
          }, {
            default: _withCtx(({
              percentage
            }) => [_createElementVNode("span", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getPercentage(percentage)), 1), _hoisted_17])]),
            _: 1
          }, 8, ["percentage"]), _createVNode(_component_el_space, {
            class: "el-home-space",
            direction: "vertical",
            size: "default"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_hoisted_19, _hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.user.usedCount ? _ctx.user.usedCount : 0), 1)]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _hoisted_24, _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.user.totalCount ? _ctx.user.totalCount - _ctx.user.usedCount : 0), 1)])]),
            _: 1
          })])])]),
          _: 1
        })]),
        _: 1
      }), _hoisted_26, _createElementVNode("div", {
        id: "table",
        class: _normalizeClass(["table-div", {
          tableDivHeight: _ctx.loginRecordList.length === 0 && !_ctx.showTable
        }])
      }, [_ctx.showTable ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: _ctx.loginRecordList,
        class: _normalizeClass(["el-home-table", {
          emptyTable: _ctx.loginRecordList.length === 0
        }])
      }, {
        empty: _withCtx(() => [_createVNode(_component_el_empty, {
          description: "没有数据",
          "image-size": _ctx.tableHeight / 2.5
        }, null, 8, ["image-size"])]),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "登录时间",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          label: "城市",
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(scop => [_createTextVNode(_toDisplayString(_ctx.getAddress(scop.row)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "ip",
          label: "IP",
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(scop => [_createTextVNode(_toDisplayString(_ctx.getIp(scop)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "设备",
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(scop => [_createTextVNode(_toDisplayString(scop.row.device === null ? '' : scop.row.device.osName) + " " + _toDisplayString(scop.row.device === null ? '' : scop.row.device.browserName), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "class"])) : _createCommentVNode("", true)], 2)]),
      _: 1
    })]),
    _: 1
  });
}